import { useEffect, useState } from "react";

import { NotificationDiv } from "../SidebarNotificationsStyles";

import { IUpfrontManualPayment } from "./model";

interface IUpfrontManualPaymentNotificationCard {
  notification: IUpfrontManualPayment;
}

const UpfrontManualPaymenNotificationCard = (
  props: IUpfrontManualPaymentNotificationCard
) => {
  const { notification } = props;

  // TODO: review, remove 'any'
  const { invoice } = notification as any;

  const [volantes, setVolantes] = useState<string>("");
  const [showDams, setShowDams] = useState<string>("");

  useEffect(() => {
    const volatesSlice = invoice.volante_details
      .slice(0, 4)
      .map((v) => v.volante_num)
      .join(",");
    const volanteSilicePoint = invoice.volante_details
      .map((v) => v.volante_num)
      .join(",");
    const damsSlice = invoice.volante_details
      .slice(0, 2)
      .map((v) => v.dam_num)
      .join(",");
    const damsSilicePoint = invoice.volante_details
      .map((v) => v.dam_num)
      .join(",");

    if (invoice.volante_details.length < 4) {
      setVolantes(volanteSilicePoint);
    } else {
      setVolantes(volatesSlice);
    }

    if (invoice.volante_details.length < 3) {
      setShowDams(damsSilicePoint);
    } else {
      setShowDams(damsSlice);
    }
  }, [invoice]);

  return (
    <div>
      <NotificationDiv
        fontWeight={500}
        fontSize="1.1rem"
        marginTop="0.5rem"
        color="#2E353D"
        paddingLeft="1rem"
      >
        Nº DAM:{" "}
        <b>
          {`${
            invoice.volante_details.length < 4
              ? `${showDams}`
              : `${showDams}...`
          }`}
        </b>
      </NotificationDiv>
      <div style={{ display: "flex", width: "31rem" }}>
        <NotificationDiv
          fontWeight={500}
          fontSize="1.1rem"
          marginTop="0.5rem"
          paddingBottom="1rem"
          color="#2E353D"
          paddingLeft="1rem"
        >
          Nº VOLANTE{invoice.volante_details.length > 1 && "S"}:{" "}
          <b>
            {`${
              invoice.volante_details.length < 4
                ? `${volantes}`
                : `${volantes}...`
            }`}
          </b>
        </NotificationDiv>
      </div>
    </div>
  );
};

export default UpfrontManualPaymenNotificationCard;
